export const INVENTORY_COUNT_PARTIAL = 'PARTIAL'
export const INVENTORY_COUNT_FULL = 'FULL'
export const INVENTORY_COUNT_INCOMING = 'INCOMING'
export const INVENTORY_COUNT_OUTGOING = 'OUTGOING'

export const Types = [
  {
    code: INVENTORY_COUNT_PARTIAL,
    label: 'Partial'
  },
  {
    code: INVENTORY_COUNT_FULL,
    label: 'Full'
  },
  {
    code: INVENTORY_COUNT_INCOMING,
    label: 'Incoming Order'
  },
  {
    code: INVENTORY_COUNT_OUTGOING,
    label: 'Outgoing Order'
  }
]

export function getLabel (code) {
  return _.get(Types.find((x) => x.code === code), 'label')
}

export default Types



// WEBPACK FOOTER //
// ./src/utils/types/inventory-count.js